<template lang="pug">
  .alert.alert-info.d-flex.flex-column.justify-content-center.align-items-center
    .form-group.mb-0
      .form-check
        input.form-check-input(type="checkbox", id="gridCheck", v-model="showCaptcha", @change="generateCaptcha")
        label.form-check-label(for="gridCheck")
          | {{ t('captcha.check') }}

    .captcha-box.mt-1.d-flex.flex-column.justify-content-center.align-items-center(v-if="showCaptcha")
      img(:src="captchaImage", alt="CAPTCHA")
      .row.justify-content-center
        input(
          type="text",
          class="form-control w-300",
          v-model="userInput",
          :placeholder="inputPlaceholder",
          @input="verifyCaptcha"
        )
      .row.mt-2.justify-content-center
        button(@click.prevent="generateCaptcha" class="btn btn-link ml-1 text-sm")
          | {{ t('captcha.regenerate') }}

    p.p-3.m-0(v-if="showErrorMessage", :class="errorClass")
      | {{ verificationMessage }}
</template>

<script>
import mixins from 'common/mixins'
import { createCaptchaImage } from 'common/captchaImage'

export default {
  mixins: [mixins.translate],
  name: 'captcha-vue',
  data() {
    return {
      showCaptcha: false,
      captchaText: '',
      captchaImage: '',
      userInput: '',
      verificationMessage: '',
      isVerified: false
    }
  },
  methods: {
    generateRandomText(length) {
      const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
      return Array.from(
        { length }, () => characters.charAt(Math.floor(Math.random() * characters.length))
      ).join('')
    },
    generateCaptcha() {
      if (!this.showCaptcha) {
        this.isVerified = false
        return
      }

      this.captchaText = this.generateRandomText(6)
      this.captchaImage = createCaptchaImage(this.captchaText)
      this.verificationMessage = ''
      this.userInput = ''
      this.isVerified = false
    },
    verifyCaptcha() {
      if (this.userInput === this.captchaText) {
        this.verificationMessage = I18n.t('captcha.success')
        this.isVerified = true
      } else {
        this.verificationMessage = I18n.t('captcha.failed')
        this.isVerified = false
      }
    },
    errorMessage() {
      if (!this.showCaptcha)
        return I18n.t('captcha.missed')
      if (!this.isVerified)
        return I18n.t('captcha.failed')
      return ''
    }
  },
  computed: {
    inputPlaceholder() {
      return I18n.t('captcha.placeholder')
    },
    showErrorMessage() {
      return this.showCaptcha && this.verificationMessage
    },
    errorClass() {
      return this.isVerified ? 'text-success' : 'text-danger'
    }
  }
}
</script>

<style scoped>
.captcha-container {
  margin: auto;
  text-align: center;
}
.w-300 {
  max-width: 300px;
}
.text-success {
  color: #1e7e34 !important;
}
img {
  margin-bottom: 0.5em;
}
</style>
